import { useCallback, useEffect, useState } from "react";

import { useResizeObserver } from "./useResizeObserver";

export function useScrollOffset(
  scrollContainerElement: HTMLElement | undefined,
  elementRef: React.RefObject<HTMLDivElement>
) {
  const [offsetTop, setOffsetTop] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  const measureOffset = useCallback(() => {
    if (elementRef.current) {
      setOffsetTop(elementRef.current.offsetTop);
    }
  }, [elementRef]);

  useResizeObserver(elementRef.current ?? undefined, { debounceMs: 100 });

  useEffect(() => {
    measureOffset();

    const scrollContainer = scrollContainerElement;

    const handleScroll = () => {
      if (scrollContainer) {
        setScrollTop(scrollContainer.scrollTop);
      }
    };

    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
      handleScroll(); // Initial measurement
    }

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [measureOffset, scrollContainerElement]);

  return { offsetTop, scrollTop };
}
